/**
 * @file 路由
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-07-06 Baidu
 */
import React, {Component} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';

import Wrapper from '../components/Wrapper/index';

export default class Routes extends Component {

    render() {
        return (
            <Router>
                <Wrapper />
            </Router>
        );
    }
}
